const startDownload = (url: string): void => {
  window.location.href = url;
};

export default startDownload;
